// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"689c7c30","732":"b5e1d43a","977":"7125bdb8"}[chunkId] + ".chunk.js";
};